import { Layout } from '@/components/Layout';
import { AlertTriangle } from 'lucide-react';

export default function Disclaimer() {
  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12 max-w-4xl" data-testid="disclaimer-page">
        <div className="flex items-center gap-4 mb-8">
          <AlertTriangle className="text-primary" size={48} />
          <h1 className="text-5xl md:text-6xl font-heading font-bold">DISCLAIMER</h1>
        </div>
        <p className="text-sm text-muted-foreground mb-8">Last Updated: February 2026</p>
        
        <div className="space-y-8 text-muted-foreground leading-relaxed">
          <div className="bg-primary/10 border-2 border-primary p-6 rounded">
            <p className="text-lg font-bold text-foreground mb-2">IMPORTANT: READ CAREFULLY</p>
            <p>
              Sports betting involves risk. You can and may lose money. Do not bet more than you can afford to lose. 
              If you or someone you know has a gambling problem, please seek help.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">1. Not Financial or Betting Advice</h2>
            <p>
              The information provided on PrimeStatLab is for informational and entertainment purposes only. 
              We are NOT licensed financial advisors, gambling consultants, or professional handicappers. 
              Our analysis should not be construed as financial or betting advice.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">2. No Guarantees of Winning</h2>
            <p>
              We do not guarantee, warrant, or promise any specific outcomes, winnings, or profits from using our analysis. 
              Sports betting is inherently unpredictable, and past performance does not indicate future results.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">3. Risk of Loss</h2>
            <p className="mb-4">
              All sports betting carries risk of financial loss. You may lose your entire investment. Key risks include:
            </p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Player injuries and unexpected performance changes</li>
              <li>Game variance and unpredictable outcomes</li>
              <li>Sportsbook rule changes and voided bets</li>
              <li>Market movements and line changes</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">4. Personal Responsibility</h2>
            <p>
              You are solely responsible for your betting decisions. We provide analysis based on available data, 
              but final decisions rest with you. Always conduct your own research and bet responsibly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">5. Legal Compliance</h2>
            <p>
              Sports betting laws vary by jurisdiction. You are responsible for ensuring your betting activities comply with local, 
              state, and federal laws. PrimeStatLab is not responsible for illegal betting activity.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">6. Age Requirement</h2>
            <p>
              You must be 18 years or older (21+ in some jurisdictions) to engage in sports betting. 
              Our content is not intended for minors.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">7. Data Accuracy</h2>
            <p>
              While we strive for accuracy, we cannot guarantee that all data, statistics, or analysis is error-free. 
              Information may be outdated or contain inaccuracies. Always verify information independently.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">8. Third-Party Links</h2>
            <p>
              Our site contains affiliate links to third-party sportsbooks. We are not responsible for their services, 
              terms, or any losses incurred through their platforms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">9. Limitation of Liability</h2>
            <p>
              PrimeStatLab, its owners, and contributors are not liable for any direct, indirect, incidental, or consequential 
              losses resulting from the use of our content. You use our services entirely at your own risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">10. Gambling Problem Resources</h2>
            <p className="mb-4">If you or someone you know has a gambling problem, help is available:</p>
            <ul className="space-y-2">
              <li><strong>National Council on Problem Gambling:</strong> 1-800-522-4700</li>
              <li><strong>Website:</strong> <a href="https://www.ncpgambling.org" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ncpgambling.org</a></li>
              <li><strong>GamTalk:</strong> Free peer support 24/7</li>
            </ul>
          </section>

          <div className="bg-surface-highlight border border-border p-6 rounded mt-8">
            <p className="font-bold text-foreground mb-2">GAMBLE RESPONSIBLY</p>
            <p>
              Set limits. Know when to stop. Never chase losses. Betting should be entertainment, not income. 
              If gambling is no longer fun, it's time to stop.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}